var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      "data-clazz": _vm.model.clazz
    }
  }, [_c("div", {
    staticClass: "panelTitle"
  }, [_vm._v(" " + _vm._s(_vm.model.clazz === "exclusiveGateway" || _vm.model.clazz === "gateway" ? _vm.i18n["exclusiveGateway"] : _vm.model.clazz === "parallelGateway" ? _vm.i18n["parallelGateway"] : _vm.i18n["inclusiveGateway"]) + " ")]), _c("div", {
    staticClass: "panelBody"
  }, [_c("DefaultDetail", {
    attrs: {
      model: _vm.model,
      onChange: _vm.onChange,
      readOnly: _vm.readOnly
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };